import React, { useEffect, useRef, useState } from 'react';
import './dataviz.scss';

const ImageScroll = ({ src1, caption1, src2, caption2 }) => {
    // const [containerHeight, setContainerHeight] = useState(0);
    // const [firstImageStyle, setFirstImageStyle] = useState({});
    
    // const firstImageRef = useRef(null);
    // const secondImageRef = useRef(null);

    const path = process.env.PUBLIC_URL;

    // const calculateContainerHeight = () => {
    //     if (firstImageRef.current && secondImageRef.current) {
    //       const firstImageHeight = firstImageRef.current.clientHeight;
    //       const secondImageHeight = secondImageRef.current.clientHeight;
    //       setContainerHeight(firstImageHeight + secondImageHeight + 240);
    //     }
    //   };

    //   const handleFirstImageLoad = (e) => {
    //     const img = e.target;
    //     if (img.naturalHeight > img.naturalWidth) {
    //         setFirstImageStyle({ maxWidth: '450px', display:'block', margin:'0 auto' });
    //     }
    //     // Use setTimeout to ensure the style has been applied before calculating height
    //     setTimeout(calculateContainerHeight, 0);
    // };

    // useEffect(() => {
    
    //     // calculateContainerHeight();
    //     window.addEventListener('resize', calculateContainerHeight);
    
    //     return () => {
    //       window.removeEventListener('resize', calculateContainerHeight);
    //     };

    //   }, []);


  return (
    // <div className="scroll-image" style={{ height: containerHeight }}>
      <div className="scroll-image">
      <div className="sticky-wrapper">
        <div className='first-image' >
            <img 
            src={path + src1} 
            alt={caption1} 
            // ref={firstImageRef}
            // onLoad={handleFirstImageLoad}
            // style={firstImageStyle}
            />
            <div className="scroll__caption">{caption1}</div>
        </div>
      </div>
      <div className='second-image' >
          <img 
          src={path + src2} 
          alt={caption2}
          // ref={secondImageRef}
          // onLoad={calculateContainerHeight}
          />
          <div className="scroll__caption">{caption2}</div>
      </div>
    </div>
  );
};

export default ImageScroll;
